import _ from "lodash";
import React from "react";

// components
import {
  SingleVisualMediaContainer,
  MultiTypeAttachments,
  MultiVisualMediaContainer,
  GridVisualMediaContainer,
} from "./components/MediaContainer/MediaContainer";

const ChatAttachmentsViewer = props => {
  const {
    totalAttachments,
    attachments,
    onMediaClick,
    mediaWrapperContainerStyle,
    showGridView = true,
  } = props;

  const isOnlyImagesOrVideos = _.every(attachments, singleAttachment =>
    _.includes(["IMAGE", "VIDEO"], singleAttachment?.type)
  );

  if (isOnlyImagesOrVideos) {
    if (totalAttachments === 1) {
      return (
        <SingleVisualMediaContainer
          attachment={_.first(attachments)}
          onMediaClick={onMediaClick}
          mediaWrapperContainerStyle={mediaWrapperContainerStyle}
        />
      );
    } else if (showGridView && totalAttachments > 2) {
      return (
        <GridVisualMediaContainer
          attachments={attachments}
          onMediaClick={onMediaClick}
          mediaWrapperContainerStyle={mediaWrapperContainerStyle}
        />
      );
    } else {
      return (
        <MultiVisualMediaContainer
          attachments={attachments}
          onMediaClick={onMediaClick}
          mediaWrapperContainerStyle={mediaWrapperContainerStyle}
        />
      );
    }
  }

  return (
    <MultiTypeAttachments
      attachments={attachments}
      onMediaClick={onMediaClick}
      mediaWrapperContainerStyle={mediaWrapperContainerStyle}
    />
  );
};

export default ChatAttachmentsViewer;
